import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";
import {
  payloadAgentsList,
  payloadDescendantAgents,
  payloadPlayersList,
  payloadRoles,
  payloadWalletIdentities,
  WalletItemType,
  payloadPlayersOptions,
  payloadPlayerWalletIdentities,
  payloadPlayerProfile,
  payloadUpdatePlayerProfile,
  payloadAgentProfile,
  payloadUpdateAgentProfile,
  payloadUpdateAgentRole,
  PayloadAddAgentWalletType,
} from "../../store/agent/agents";

const getList = (data: payloadAgentsList) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getPlayerList = (data: payloadPlayersList) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.playerList;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getBrandsList = (data: payloadAgentsList) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.conditions.brands_list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getWallets = () => {
  const endpoint = api.agent.agentList.walletList;

  return fetch(
    `${endpoint}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getDescendantAgents = (data: payloadDescendantAgents) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.descendantAgents;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getRoles = () => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.agent.agentList.roles}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getWalletIdentities = (data: payloadWalletIdentities) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.agent.agentList.walletIdentities.replace('{agentId}', `${data.agentId}`)}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const createAgent = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.createAgent;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const createPlayer = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.createPlayer;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const enableWallet = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.enableWallet;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const disableWallet = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.disableWallet;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const addWallet = (data: WalletItemType) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.addWallet;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const addAgentWallet = (data: PayloadAddAgentWalletType) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.addAgentWallet.replace('{agentId}', `${data.agentId}`);

  const payload = {
   ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getAgentBalanceById = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.getAgentBalance.replace('{agentId}', `${data.agentId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getAgentNetworkBalanceById = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.agent.agentList.getNetworkBalance.replace('{agentId}', `${data.agentId}`)}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getPlayerBalanceById = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.agent.agentList.getPlayerBalance.replace('{playerId}', `${data.playerId}`)}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const setTransferToAgent = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.transferToAgent.replace('{agentId}', `${data.agentId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getPlayersOptions = (data: payloadPlayersOptions) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.players;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getPlayerWalletIdentities = (data: payloadPlayerWalletIdentities) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.agent.agentList.playerWalletIdentities.replace('{playerId}', `${data.playerId}`)}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const setTransferToPlayer = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.transferToPlayer.replace('{playerId}', `${data.playerId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getPlayerProfile = (data: payloadPlayerProfile) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.playerProfile.replace('{playerId}', `${data.playerId}`);

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getExternalPlayerProfile = (data: payloadPlayerProfile) => {
  const endpoint = api.agent.agentList.externalPlayerProfile.replace('{playerId}', `${data.playerId}`);

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const updatePlayerProfile = (data: payloadUpdatePlayerProfile) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.updatePlayerProfile.replace('{playerId}', `${data.playerId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('PATCH', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getAgentProfile = (data: payloadAgentProfile) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.agentProfile.replace('{agentId}', `${data.agentId}`);

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const updateAgentProfile = (data: payloadUpdateAgentProfile) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.updateAgentProfile.replace('{agentId}', `${data.agentId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('PATCH', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const updateAgentRole = (data: payloadUpdateAgentRole) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.updateAgentRole.replace('{agentId}', `${data.agentId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('PATCH', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getFilterRoles = () => {
  const endpoint = api.agent.agentList.filter_roles;

  return fetch(
    `${endpoint}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const toggleBlockAgent = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.toggleBlockAgent
    .replace('{agentId}', `${data.agentId}`)
    .replace('{statusBlock}', `${data.status === 'blocked' ? 'unblock' : 'block'}`);

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getBetListFilters = () => {
  const endpoint = api.agent.agentList.betListFilters;

  return fetch(
    `${endpoint}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getCasinoBetListFilters = () => {
  const endpoint = api.agent.agentList.casinoBetListFilters;

  return fetch(
    `${endpoint}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const setAgentNewPassword = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.agentNewPassword.replace('{agentId}', `${data.agentId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('PATCH', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const toggleBlockPlayer = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.toggleBlockPlayer
    .replace('{playerId}', `${data.playerId}`)
    .replace('{statusBlock}', `${data.status === 'blocked' ? 'unblock' : 'block'}`);

  const payload = {
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getPlayerStatus = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.getPlayerStatus
    .replace('{playerId}', `${data.playerId}`);

  const payload = {
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const setPlayerNewPassword = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.playerNewPassword.replace('{playerId}', `${data.playerId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('PUT', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getAgentMetrics = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.agentMetrics.replace('{agentId}', data.agentId);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getPlayerMetrics = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.playerMetrics.replace('{playerId}', data.playerId);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

export const agentsService = {
  getList,
  getBrandsList,
  getWallets,
  enableWallet,
  disableWallet,
  addWallet,
  addAgentWallet,
  getDescendantAgents,
  getRoles,
  getWalletIdentities,
  createAgent,
  getAgentBalanceById,
  getAgentNetworkBalanceById,
  getPlayerBalanceById,
  createPlayer,
  getPlayerList,
  setTransferToAgent,
  getPlayersOptions,
  getPlayerWalletIdentities,
  setTransferToPlayer,
  getPlayerProfile,
  getExternalPlayerProfile,
  updatePlayerProfile,
  getAgentProfile,
  updateAgentProfile,
  updateAgentRole,
  getFilterRoles,
  toggleBlockAgent,
  getBetListFilters,
  getCasinoBetListFilters,
  setAgentNewPassword,
  toggleBlockPlayer,
  getPlayerStatus,
  setPlayerNewPassword,
  getAgentMetrics,
  getPlayerMetrics,
};
